module.exports = __webpack_public_path__ + "img/anesthesiology.97449063.png";